import React, { useEffect, useState } from "react";

import Button from "../button/Button";
import { useUser } from "../../context/UserContext";
import { fetchPostJSON } from "../../utils/api-helpers";

import styles from "./paymentIssueNotice.module.css";

/**
 * Tells a customer with an unpaid invoice they can't rotate, with links to sort it in Stripe
 */
const PaymentIssueNotice = (): JSX.Element => {
  const { userProfile } = useUser();
  const [portalUrl, setPortalUrl] = useState<string>();

  // Stripe's hosted page for the oldest unpaid invoice
  const invoiceUrl =
    userProfile?.stripe_meta?.unpaid_invoices?.[0]?.invoice_url;

  useEffect(() => {
    // Stripe customer portal, where they can update their card details
    const getPortalUrl = async () => {
      const response = await fetchPostJSON("/api/user_plan", {
        customer_id: userProfile.stripe_customer_id,
      });

      if (response?.url) {
        setPortalUrl(response.url);
      }
    };

    if (userProfile?.stripe_customer_id) {
      getPortalUrl();
    }
  }, [userProfile?.stripe_customer_id]);

  return (
    <div className={styles.container}>
      <p>
        <b>There&apos;s an issue with your latest payment.</b> Please pay the
        outstanding amount before placing your next order. Any questions? Get
        in touch at{" "}
        <a href="mailto:hello@orcollective.co.uk">hello@orcollective.co.uk</a>.
      </p>
      <div className={styles.actions}>
        {invoiceUrl && (
          <Button
            type="button"
            text="Pay outstanding amount"
            onClick={() => {
              window.open(invoiceUrl, "_blank");
            }}
          />
        )}
        {portalUrl && (
          <a href={portalUrl}>Update your card details</a>
        )}
      </div>
      <p className={styles.note}>
        Once your payment has gone through, it can take up to 2 hours before
        you can place a new order.
      </p>
    </div>
  );
};

export default PaymentIssueNotice;
